module.exports = __webpack_public_path__ + "img/Don't-worry-en.0d26652.png";